import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { api } from "../lib/api";
import { Field } from "./common";
import { Input } from "./ui/input";
import { shiftHours, splitShift } from "../lib/format";
import { cn } from "../lib/utils";

let cached = null;
export const setWorkSettingsCache = (value) => {
  cached = value;
};

export function useWorkSettings() {
  const [settings, setSettings] = useState(cached);
  useEffect(() => {
    if (cached) return;
    api.get("/settings").then((r) => {
      cached = r.data;
      setSettings(r.data);
    });
  }, []);
  return settings;
}

const hoursLabel = (info) => {
  if (!info) return "Orario non valido: la fine deve essere dopo l'inizio";
  const label = info.hours === 1 ? "ora lavorata" : "ore lavorate";
  return `${info.hours.toLocaleString("it-IT")} ${label}${info.withBreak ? " (pausa pranzo esclusa)" : ""}`;
};

export function ShiftFields({ value, onChange, testid, big }) {
  const settings = useWorkSettings();
  const [from, to] = splitShift(value);
  const info = shiftHours(value, settings?.lunch_break);
  const full = settings?.default_shift;
  const cls = big ? "h-12" : undefined;
  return (
    <div className="space-y-1.5" data-testid={`${testid}-fields`}>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Dalle"><Input type="time" lang="it" className={cls} value={from} onChange={(e) => onChange(`${e.target.value}-${to}`)} data-testid={`${testid}-from`} /></Field>
        <Field label="Alle"><Input type="time" lang="it" className={cls} value={to} onChange={(e) => onChange(`${from}-${e.target.value}`)} data-testid={`${testid}-to`} /></Field>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-2 text-xs">
        <span className={cn("flex items-center gap-1", info ? "text-muted-foreground" : "text-red-400")} data-testid={`${testid}-hours`}>
          <Clock className="h-3.5 w-3.5" />{hoursLabel(info)}
        </span>
        {full && value !== full && (
          <button type="button" className="text-amber-400 hover:underline" onClick={() => onChange(full)} data-testid={`${testid}-fullday-btn`}>Giornata intera ({full})</button>
        )}
      </div>
    </div>
  );
}
